import React, { useState } from "react";

import { useDispatch } from "react-redux";

import "../../../Widgets/myBoardsWidget/MyBoardsWidget.less";

interface MyBoardsSettingsProps {
   value: any;

   data: any;
}

const MyBoardsSettings: React.FC<MyBoardsSettingsProps> = ({ value, data }) => {
   const dispatch = useDispatch();

   const [settings, setSettings] = useState({
      ...value
   });

   return (
      <>
         <div className="my-boards-settings-container">
            <span className="my-boards-settings-container__face">(˚Δ˚)</span>
            <span>There is no settings for this widget</span>
         </div>
      </>
   );
};

export default MyBoardsSettings;
